import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://crypto-expense-management-backend.onrender.com';

export interface ExpenseCategory {
  id: number;
  name: string;
  description?: string;
  is_active: boolean;
  org_id: number;
  created_at: string;
  updated_at: string;
}

export interface ExpensePolicy {
  id: number;
  name: string;
  description?: string;
  is_active: boolean;
  org_id: number;
  created_at: string;
  updated_at: string;
}

export class ExpenseCategoryService {
  static async getCategories(): Promise<ExpenseCategory[]> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expense-categories/`);
    return response.data;
  }

  static async getCategory(id: number): Promise<ExpenseCategory> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expense-categories/${id}`);
    return response.data;
  }
}

export class ExpensePolicyService {
  static async getPolicies(): Promise<ExpensePolicy[]> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expense-policies/`);
    return response.data;
  }

  static async getPolicy(id: number): Promise<ExpensePolicy> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expense-policies/${id}`);
    return response.data;
  }

  static async getPoliciesByCategory(categoryId: number, orgId: number): Promise<ExpensePolicy[]> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expense-policies/category/${categoryId}?org_id=${orgId}`);
    return response.data;
  }
}
